import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

interface DeleteGuardrailsConfigProps {
  id: string;
}

export const deleteGuardrailsConfig = async ({
  id,
}: DeleteGuardrailsConfigProps) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest({
    url: `/guardrails/${orgId}/${id}`,
    target: 'platform',
    method: 'DELETE',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to delete guardrails config' };
  }

  return response;
};
